// extracted by mini-css-extract-plugin
export default {"HeaderSpacer":"Header_HeaderSpacer__sssjq","Container":"Header_Container__Fdi3y","Wrapper":"Header_Wrapper__5I5cp","Logo":"Header_Logo__C8KV+"};